import { Switch } from 'antd';
import { IRestColumnProps } from 'components/rest/Table/TableColumn';
import RestList from 'containers/rest/List';
import React from 'react';
import { Link } from 'react-router-dom';
import { DynamicObjectType, FilterFromUrlResponseType } from 'types/commons';
import { formatDateTime } from 'utils/formattedString';

const breadcrumbs = [
  {
    title: 'common.page.settings',
    href: '/settings',
  },
  {
    title: 'common.page.customerBlacklist',
  },
];

const columns: IRestColumnProps[] = [
  {
    name: 'id',
    title: 'ID',
    isDefault: true,
  },
  {
    name: 'telephone',
    title: 'telephone',
    isDefault: true,
  },
  {
    name: 'email',
    title: 'Email',
    isDefault: true,
  },
  {
    name: 'nickName',
    title: 'Nick Name',
    isDefault: true,
    render: (dt, rc: DynamicObjectType) => (
      <Link
        className="text-highlight min-w-[100px] block truncate"
        to={`/settings/bannedCustomers/${rc?.id}/show`}
      >{`${rc?.firstName} ${rc.lastName}`}</Link>
    ),
  },
  {
    name: 'reason',
    title: 'Reason',
    isDefault: true,
  },
  {
    name: 'note',
    title: 'Note',
    isDefault: true,
  },
  {
    name: 'banCreatedAt',
    title: 'Banned Date',
    render: (d) => <p className="min-w-[150px]">{formatDateTime(d)}</p>,
    isDefault: true,
  },
  {
    name: 'banByUser',
    title: 'Banned By',
    render: (d, rc) => (
      <p className="min-w-[150px]">{`${rc?.firstName || ''} ${rc?.lastName || ''} `}</p>
    ),
    isDefault: true,
  },
  {
    name: 'isBanned',
    title: 'Is Banned',
    render: (d, r, i, handleEditRow) => {
      return (
        <div className="min-w-[150px]">
          <Switch
            onChange={(newVal) => {
              handleEditRow({ id: r.id, isBanned: newVal });
            }}
            checked={!!d}
          />
        </div>
      );
    },
    isDefault: true,
  },
];

const BannedCustomers = () => {
  const restInitialFilter: FilterFromUrlResponseType = {
    join: ['banByUser'],
    filters: [
      {
        condition: 'and',
        key: 'isBanned',
        operator: 'is',
        value: true,
      },
    ],
  };

  return (
    <RestList
      initialFilter={restInitialFilter}
      columns={columns}
      model="bannedCustomers"
      breadcrumbs={breadcrumbs}
      hasSearch
      hasImport={false}
      hasExport={false}
      hasFilter
      hasCustomLayout={false}
      searchKeys={['firstName', 'lastName', 'email', 'telephone']}
      placeholderInputSearch="Search by name, email, phone"
    />
  );
};

export default BannedCustomers;
